/**
 * Press UI Logic
 * All UI-related logic: event handlers
 */

import { useCallback } from 'react';

/**
 * Hook for managing press page state
 * @param {function} t - Translation function
 * @returns {{handlePressReleaseClick: function, handleMediaItemClick: function, handlePressMentionClick: function, getTranslationArray: function}}
 */
export function usePressUI(t) {
  const handlePressReleaseClick = useCallback((title) => {
    console.log(`Reading press release: ${title}`);
  }, []);

  const handleMediaItemClick = useCallback((item) => {
    console.log(`Downloading media item: ${item}`);
  }, []);

  const handlePressMentionClick = useCallback((title) => {
    console.log(`Reading press mention: ${title}`);
  }, []);

  const getTranslationArray = useCallback((key) => {
    const value = t(key);
    return Array.isArray(value) ? value : [];
  }, [t]);

  return {
    handlePressReleaseClick,
    handleMediaItemClick,
    handlePressMentionClick,
    getTranslationArray
  };
}


